export default {
  "Discover or search for one of our recent media in the library of our community.":
    "Découvrez ou recherchez un de nos supports media récent dans la bibliothèque de notre communauté.",
  "All photos and images published by our community.":
    "Toutes les photos et images publiées par notre communauté.",
  "All videos and small films published or relayed by our community.":
    "Toutes les video et et petits films publiés ou relayés par notre communauté.",
  "All PDF supports published or relayed by our community.":
    "Tous les supports PDF publiés ou relayés par notre communauté.",
  "All PPT (powerpoint) supports published or relayed by our community.":
    "Tous les supports PPT (powerpoint) publiés ou relayés par notre communauté.",
  "All media supports assembled around a theme, a moment or a context.":
    "Tous les supports medias assemblés autour d'un thème, d'un moment ou d'un contexte.",
  Settings: "Paramètres",
  "Sign in / Join": "Connectez-vous / s'inscrire",
  "See more": "Voir plus",
  Add: "Ajouter",
  "Drag and drop files here, or click to select the files to download.":
    "Faites glisser et déposer des fichiers ici, ou cliquez pour sélectionner les fichiers à télécharger.",
  "Select files": "Sélectionner des fichiers",
  "Maximum upload file size: 8MB.":
    "Taille maximale du fichier à télécharger: 8Mo.",
  "Add a logo": "Ajouter un logo",
  "Apply a mask": "Appliquer un masque",
  "Apply a mask to your medias": "Appliquer un masque à vos médias",
  "Apply a logo to your medias": "Appliquez un logo à vos médias",
  Apply: "Appliquer",
  Cancel: "Annuler",
  "Mask informations": "Informations sur le masque",
  Title: "Titre",
  Description: "Description",
  "Uploaded at": "Téléchargé le",
  "File type": "Type de fichier",
  "File size": "Taille du fichier",
  Dimensions: "Dimensions",
  "Select or import your mask": "Séléctionnez ou importez votre masque",
  "Select or import your logo": "Sélectionnez ou importez votre logo",
  "Select size": "Sélectionnez la taille",
  Small: "Petit",
  Medium: "Moyen",
  Large: "Large",
  "eXtra Large": "Extra Large",
  "Select position": "Sélectionner la position",
  "Select all": "Tout sélectionner",
  "Deselect All": "Tout déslectionner"
};



// WEBPACK FOOTER //
// ./src/i18n/fr.js